export default __webpack_public_path__ + "static/media/uploadTw1.a26e1be4.png";